import { Grade, Grades } from "src/constants/Grades";
import { Planet, Planets } from "src/constants/Planets";
import PhaserLandscapeGame from "src/games/LandscapingGame/Main";
import PhaserDiagnosisGame from "src/games/DiagnosisGame/Main";
import PhaserCollageGame from "src/games/CollageGame/Main";
import PhaserJobMatchingGame from "src/games/JobMatchingGame/Main";
import PhaserColonyGame from "src/games/ColonyGame/Main";
import PhaserPuzzleSlider from "src/games/PuzzleSlider/Main";

import PhaserPlumbingGame from "src/games/PlumbingGame/Main";
import PhaserUniversityGame from "src/games/UniversityGame/Main";
import PhaserPaintGame from "src/games/PaintGame/Main";
import PhaserDinerGame from "src/games/DinerGame/Main";
import PhaserCareerFairGame from "src/games/CareerFairGame/Main";
import PhaserOrganizeDeskGame from "src/games/OrganizeDeskGame/Main";

import PhaserDiseasedTreesGame from "src/games/DiseasedTreesGame/Main";
import PhaserXraySlider from "src/games/XraySlider/Main";
import PhaserTerraformGame from "src/games/DesertTerraformGame/Main";
import PhaserFitFiveGame from "src/games/FitFiveGame/Main";
import PhaserHotelAuroraGame from "src/games/HotelAuroraGame/Main";
import PhaserWarehouseGame from "src/games/WarehouseGame/Main";

import PhaserRocketRepairGame from "src/games/RocketRepairGame/Main";
import PhaserProgramRobotGame from "src/games/ProgramRobotGame/Main";
import PhaserJigsawPuzzleGame from "src/games/JigsawPuzzleGame/Main";
import PhaserSpacePortGame from "src/games/SpacePortGame/Main";
import PhaserMailDeliveryGame from "src/games/MailDeliveryGame/Main";
import PhaserShipPaintingGame from "src/games/ShipPainting/Main";
import PhaserSpacePetsGame from "src/games/SpacePets/Main";
import PhaserWaiterMemoryGame from "src/games/WaiterMemoryGame/Main";
import PhaserZooGame from "src/games/ZooGame/Main";

import PhaserLibrarianGame from "src/games/LibrarianGame/Main";
import PhaserUniformDesignGame from "src/games/UniformDesignGame/main";
import PhaserOceanCleanupGame from "src/games/OceanCleanupGame/Main";
import PhaserConstructionMazeGame from "src/games/ConstructionMazeGame/Main";
import PhaserVendingMachine from "src/games/VendingMachine/Main";
import PhaserSeekAndFindGame from "src/games/SeekAndFindGame/Main";
import PhaserFindHelpersGame from "src/games/FindHelpersGame/Main";
import PhaserTicketTakerGame from "src/games/TicketTakerGame/Main";
import PhaserFossilFinderGame from "src/games/FossilFinderGame/Main";
import PhaserGroceryBaggerGame from "src/games/GroceryBaggerGame/Main";
import PhaserCakeDecoratingGame from "src/games/CakeDecorating/Main";
import PhaserRideMechanicGame from "src/games/RideMechanicGame/Main";
import PhaserStarballGame from "src/games/StarballGame/Main";
import PhaserCityBuilderGame from "src/games/CityBuilderGame/Main";
import PhaserFacePaintingGame from "src/games/FacePainting/Main";

// I REALLY didn't want to have to make this...
export interface Game {
    id: number;
    name: string;
    grade: Grade;
    planet: Planet;
    component: any;
}

export class Games {
    public static readonly Default: Game = { id: 0, name: "Default", grade: Grades.Default, planet: Planets.Default, component: null };

    // 5th grade
    public static readonly Landscaping: Game = { id: 1, name: "Landscaping", grade: Grades.Fifth, planet: Planets.R, component: PhaserLandscapeGame };
    public static readonly Diagnosis: Game = { id: 2, name: "Diagnosis", grade: Grades.Fifth, planet: Planets.I, component: PhaserDiagnosisGame };
    public static readonly Collage: Game = { id: 3, name: "Collage", grade: Grades.Fifth, planet: Planets.A, component: PhaserCollageGame };
    public static readonly JobMatching: Game = { id: 4, name: "JobMatching", grade: Grades.Fifth, planet: Planets.S, component: PhaserJobMatchingGame };
    public static readonly Colony: Game = { id: 5, name: "Colony", grade: Grades.Fifth, planet: Planets.E, component: PhaserColonyGame };
    public static readonly PuzzleSlider: Game = { id: 6, name: "PuzzleSlider", grade: Grades.Fifth, planet: Planets.C, component: PhaserPuzzleSlider };

    // 4th grade
    public static readonly Plumbing: Game = { id: 7, name: "Plumbing", grade: Grades.Fourth, planet: Planets.R, component: PhaserPlumbingGame };
    public static readonly University: Game = { id: 8, name: "University", grade: Grades.Fourth, planet: Planets.I, component: PhaserUniversityGame };
    public static readonly Paint: Game = { id: 9, name: "Paint", grade: Grades.Fourth, planet: Planets.A, component: PhaserPaintGame };
    public static readonly Diner: Game = { id: 10, name: "Diner", grade: Grades.Fourth, planet: Planets.S, component: PhaserDinerGame };
    public static readonly CareerFair: Game = { id: 11, name: "CareerFair", grade: Grades.Fourth, planet: Planets.E, component: PhaserCareerFairGame };
    public static readonly OrganizeDesk: Game = { id: 12, name: "OrganizeDesk", grade: Grades.Fourth, planet: Planets.C, component: PhaserOrganizeDeskGame };

    // 3th grade
    public static readonly DiseasedTrees: Game = { id: 13, name: "DiseasedTrees", grade: Grades.Third, planet: Planets.R, component: PhaserDiseasedTreesGame };
    public static readonly XRay: Game = { id: 14, name: "XRay", grade: Grades.Third, planet: Planets.I, component: PhaserXraySlider };
    public static readonly DesertTerraform: Game = { id: 15, name: "DesertTerraform", grade: Grades.Third, planet: Planets.A, component: PhaserTerraformGame };
    public static readonly FitFive: Game = { id: 16, name: "FitFive", grade: Grades.Third, planet: Planets.S, component: PhaserFitFiveGame };
    public static readonly HotelAurora: Game = { id: 17, name: "HotelAurora", grade: Grades.Third, planet: Planets.E, component: PhaserHotelAuroraGame };
    public static readonly Warehouse: Game = { id: 18, name: "Warehouse", grade: Grades.Third, planet: Planets.C, component: PhaserWarehouseGame };

    // 2th grade
    public static readonly RocketRepair: Game = { id: 19, name: "RocketRepair", grade: Grades.Second, planet: Planets.R, component: PhaserRocketRepairGame };
    public static readonly ProgramRobot: Game = { id: 20, name: "ProgramRobot", grade: Grades.Second, planet: Planets.I, component: PhaserProgramRobotGame };
    public static readonly ShipPainting: Game = { id: 21, name: "ShipPainting", grade: Grades.Second, planet: Planets.A, component: PhaserShipPaintingGame };
    public static readonly JigsawPuzzle: Game = { id: 22, name: "JigsawPuzzle", grade: Grades.Second, planet: Planets.S, component: PhaserJigsawPuzzleGame };
    public static readonly SpacePort: Game = { id: 23, name: "SpacePort", grade: Grades.Second, planet: Planets.E, component: PhaserSpacePortGame };
    public static readonly MailDelivery: Game = { id: 24, name: "MailDelivery", grade: Grades.Second, planet: Planets.C, component: PhaserMailDeliveryGame };

    // 1th grade
    public static readonly OceanCleanup: Game = { id: 25, name: "OceanCleanup", grade: Grades.First, planet: Planets.R, component: PhaserOceanCleanupGame };
    public static readonly CityBuilder: Game = { id: 26, name: "CityBuilder", grade: Grades.First, planet: Planets.I, component: PhaserCityBuilderGame };
    public static readonly UniformDesign: Game = { id: 27, name: "UniformDesign", grade: Grades.First, planet: Planets.A, component: PhaserUniformDesignGame };
    public static readonly SeekAndFind: Game = { id: 28, name: "SeekAndFind", grade: Grades.First, planet: Planets.S, component: PhaserSeekAndFindGame };
    public static readonly VendingMachine: Game = { id: 29, name: "VendingMachine", grade: Grades.First, planet: Planets.E, component: PhaserVendingMachine };
    public static readonly SpacePets: Game = { id: 30, name: "SpacePets", grade: Grades.First, planet: Planets.C, component: PhaserSpacePetsGame };

    // Kth grade
    public static readonly ConstructionMaze: Game = { id: 31, name: "ConstructionMaze", grade: Grades.K, planet: Planets.R, component: PhaserConstructionMazeGame };
    public static readonly Zoo: Game = { id: 32, name: "Zoo", grade: Grades.K, planet: Planets.I, component: PhaserZooGame };
    public static readonly CakeDecorating: Game = { id: 33, name: "CakeDecorating", grade: Grades.K, planet: Planets.A, component: PhaserCakeDecoratingGame };
    public static readonly WaiterMemory: Game = { id: 34, name: "WaiterMemory", grade: Grades.K, planet: Planets.S, component: PhaserWaiterMemoryGame };
    public static readonly Starball: Game = { id: 35, name: "Starball", grade: Grades.K, planet: Planets.E, component: PhaserStarballGame };
    public static readonly Librarian: Game = { id: 36, name: "Librarian", grade: Grades.K, planet: Planets.C, component: PhaserLibrarianGame };

    // PreK grade
    public static readonly RideMechanic: Game = { id: 37, name: "RideMechanic", grade: Grades.PreK, planet: Planets.R, component: PhaserRideMechanicGame };
    public static readonly FossilFinder: Game = { id: 38, name: "FossilFinder", grade: Grades.PreK, planet: Planets.I, component: PhaserFossilFinderGame };
    public static readonly FacePainting: Game = { id: 39, name: "FacePainting", grade: Grades.PreK, planet: Planets.A, component: PhaserFacePaintingGame };
    public static readonly FindHelpers: Game = { id: 40, name: "FindHelpers", grade: Grades.PreK, planet: Planets.S, component: PhaserFindHelpersGame };
    public static readonly TicketTaker: Game = { id: 41, name: "TicketTaker", grade: Grades.PreK, planet: Planets.E, component: PhaserTicketTakerGame };
    public static readonly GroceryBagger: Game = { id: 42, name: "GroceryBagger", grade: Grades.PreK, planet: Planets.C, component: PhaserGroceryBaggerGame };

    public static All: Game[] = [
        Games.Landscaping,
        Games.Diagnosis,
        Games.Collage,
        Games.JobMatching,
        Games.Colony,
        Games.PuzzleSlider,
        Games.Plumbing,
        Games.University,
        Games.Paint,
        Games.Diner,
        Games.CareerFair,
        Games.OrganizeDesk,
        Games.DiseasedTrees,
        Games.XRay,
        Games.DesertTerraform,
        Games.FitFive,
        Games.HotelAurora,
        Games.Warehouse,
        Games.RocketRepair,
        Games.ProgramRobot,
        Games.ShipPainting,
        Games.JigsawPuzzle,
        Games.SpacePort,
        Games.MailDelivery,
        Games.SpacePets,
        Games.OceanCleanup,
        Games.CityBuilder,
        Games.UniformDesign,
        Games.SeekAndFind,
        Games.GroceryBagger,
        Games.VendingMachine,
        Games.FindHelpers,
        Games.TicketTaker,
        Games.FacePainting,
        Games.FossilFinder,
        Games.CakeDecorating,
        Games.Starball,
        Games.Librarian,
        Games.Zoo,
        Games.WaiterMemory,
        Games.RideMechanic,
        Games.ConstructionMaze,
    ];

    public static FindById(id: number) {
        return this.All.find(x => x.id === id) || this.Default;
    }

    public static FindByGradeAndPlanet(gradeId: number, planetId: number) {
        return this.All.find(x => x.grade.id === gradeId && x.planet.id === planetId) || this.Default;
    }
}



// WEBPACK FOOTER //
// ./src/constants/Games.ts